export const SAVE_REQUEST = 'save/SAVE_REQUEST';
export const SAVE_SUCCESS = 'save/SAVE_SUCCESS';
export const SAVE_FAILURE = 'save/SAVE_FAILURE';
export const SAVE_CANCELLED = 'save/SAVE_CANCELLED';
export const SAVE_ALL_REQUEST = 'save/SAVE_ALL_REQUEST';
export const SAVE_ALL_SUCCESS = 'save/SAVE_ALL_SUCCESS';
export const SAVE_ALL_FAILURE = 'save/SAVE_ALL_FAILURE';
export const SAVE_SIGNATURES_REQUEST = 'save/SAVE_SIGNATURES_REQUEST';
export const SAVE_SIGNATURES_SUCCESS = 'save/SAVE_SIGNATURES_SUCCESS';
export const SAVE_SIGNATURES_FAILURE = 'save/SAVE_SIGNATURES_FAILURE';
export const START_SUBMISSION = 'save/START_SUBMISSION';
export const SUBMISSION_COMPLETE = 'save/SUBMISSION_COMPLETE';
export const SUBMIT_REQUEST = 'save/SUBMIT_REQUEST';
export const SUBMIT_SUCCESS = 'save/SUBMIT_SUCCESS';
export const SUBMIT_FAILURE = 'save/SUBMIT_FAILURE';
export const STATUS_REQUEST = 'save/STATUS_REQUEST';
export const STATUS_SUCCESS = 'save/STATUS_SUCCESS';
export const STATUS_FAILURE = 'save/STATUS_FAILURE';
export const SAVE_ALL_FOR_PDF_REQUEST = 'save/SAVE_ALL_FOR_PDF_REQUEST';
